// A standard debounce function to limit how often a function runs
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

// Wrap the target function in the debounce (e.g., wait 300ms after the last change)
const debouncedGetCartInfo = debounce(() => {
    if (typeof window.getCartInfo === 'function') {
        // window.getCartInfo();
    }
}, 300);

document.addEventListener("DOMContentLoaded", () => {
    // Select the target node
    const targetNode = document.querySelector('.cart-item-list__body');

    // Check if the element exists before attaching the observer
    if (targetNode) {
        // Configure the observer to watch for all types of changes inside the target
        const config = { 
            childList: true,   // Watches for added/removed nodes
            subtree: true,     // Extends watching to all descendant children
            attributes: true,  // Watches for attribute changes on the nodes
            characterData: true // Watches for text content changes
        };

        // Create the MutationObserver
        const observer = new MutationObserver((mutationsList, observer) => {
            // Trigger the debounced function whenever a mutation is detected
            debouncedGetCartInfo();
        });

        // Start observing the target node
        observer.observe(targetNode, config);
        
        // Optional: observer.disconnect() can be used later to stop watching
    } else {
        console.warn("Target element '.cart-item-list__body' was not found in the DOM.");
    }
});